type NumberOfCarsContext = {
	numberOfCarsReceived?: boolean | null;
};

/** FLOW sends the flag in Finland only, so an absent or null flag never asks. */
export const shouldAskNumberOfCars = (context: NumberOfCarsContext): boolean =>
	context.numberOfCarsReceived === false;

export const isValidNumberOfCars = (value: unknown): value is number =>
	typeof value === "number" && Number.isInteger(value) && value >= 0;
